export const getPriceUnit = (locale: string) => {
  switch (locale) {
    case 'ja':
      return '円'
    case 'en':
      return 'yen'
    case 'zh-TW':
      return '日幣'
    default:
      return '円'
  }
}
